// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"274bc0c8","437":"11eeddaa","518":"c296b4a0","539":"3a599be3","813":"c38a8af5","856":"8cc9c5c0"}[chunkId] + ".chunk.js";
};